import {
  ShoppingCart,
  Clock,
  Package,
  RotateCcw,
  DollarSign,
  TrendingUp,
} from 'lucide-react';
import { globalOrders } from '@/data/globalOrdersMockData';
import type { KpiDef } from './useOrdersPage.types';

export const PAGE_SIZE = 15;

export const statusOptions = ['All', 'New', 'Pending Confirmation', 'Confirmed', 'Packed', 'Shipped', 'Delivered', 'Canceled', 'Return Initiated', 'Returned', 'Refund Pending', 'Refunded'] as const;
export const marketplaceOptions = ['All', 'Amazon', 'Flipkart', 'Wish', 'Meesho', 'Coupang'] as const;
export const paymentOptions = ['All', 'COD', 'Prepaid'] as const;
export const riskOptions = ['All', 'Low', 'Medium', 'High'] as const;
export const slaOptions = ['All', 'On track', 'At risk', 'Breached'] as const;
export const syncOptions = ['All', 'Healthy', 'Warning', 'Failed'] as const;

export const statusColors = {
  New: 'PENDING',
  'Pending Confirmation': 'PENDING',
  Confirmed: 'ACTIVE',
  Packed: 'ACTIVE',
  Shipped: 'ACTIVE',
  Delivered: 'OK',
  Canceled: 'DISABLED',
  'Return Initiated': 'WARNING',
  Returned: 'FAILED',
  'Refund Pending': 'WARNING',
  Refunded: 'FAILED',
} as const;

export const riskColors = { Low: 'ACTIVE', Medium: 'WARNING', High: 'FAILED' } as const;
export const slaColors = { 'On track': 'ACTIVE', 'At risk': 'WARNING', Breached: 'FAILED' } as const;

export const payBadge = {
  COD: 'bg-amber-50 dark:bg-amber-950/50 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800',
  Prepaid: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 border-slate-200 dark:border-slate-700',
} as const;

export const mktBadge = {
  Amazon: 'bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-400',
  Flipkart: 'bg-blue-50 dark:bg-blue-950/40 text-blue-700 dark:text-blue-400',
  Wish: 'bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-400',
  Meesho: 'bg-pink-50 dark:bg-pink-950/40 text-pink-700 dark:text-pink-400',
  Coupang: 'bg-teal-50 dark:bg-teal-950/40 text-teal-700 dark:text-teal-400',
} as const;

export const iconBg: Record<string, string> = {
  indigo: 'bg-indigo-50 dark:bg-indigo-950 text-indigo-600 dark:text-indigo-400',
  amber: 'bg-amber-50 dark:bg-amber-950 text-amber-600 dark:text-amber-400',
  emerald: 'bg-emerald-50 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400',
  rose: 'bg-rose-50 dark:bg-rose-950 text-rose-600 dark:text-rose-400',
  orange: 'bg-orange-50 dark:bg-orange-950 text-orange-600 dark:text-orange-400',
  teal: 'bg-teal-50 dark:bg-teal-950 text-teal-600 dark:text-teal-400',
};

export const kpiDefs: KpiDef[] = [
  { key: 'totalToday', label: 'Total Orders (Today)', color: 'indigo', fmt: 'number', filter: null, icon: ShoppingCart },
  { key: 'pending', label: 'Pending Orders', color: 'amber', fmt: 'number', filter: 'pending', icon: Clock },
  { key: 'shippedToday', label: 'Shipped Today', color: 'emerald', fmt: 'number', filter: 'shipped', icon: Package },
  { key: 'returnsOpen', label: 'Returns Open', color: 'rose', fmt: 'number', filter: 'returns', icon: RotateCcw },
  { key: 'refunds30d', label: 'Refunds (30D)', color: 'orange', fmt: 'number', filter: 'refunds', icon: DollarSign },
  { key: 'gmv30d', label: 'GMV (30D)', color: 'teal', fmt: 'currency', filter: null, icon: TrendingUp },
];

export const sellerList = [...new Set(globalOrders.map((o) => o.seller))].sort();
